import React from 'react';
import PropTypes from 'prop-types';

import {Graphics} from './components/Graphics';
import {Controls} from './components/Controls';

import './style.scss';

export class Pipette extends React.Component {

  componentWillMount(){
    this.props.createPipette({
      props: this.props.defaultProps
    })
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.controlsVisible !== prevProps.controlsVisible){
      this.props.showMoveMenu({display: false});
    }
  }

  showControls = ()=> {
    this.props.hideAllControls();
    this.props.setPipetteControlVisibility({id: this.props.id, controlsVisible: true});
  }

  pipetteSelected = () => {

    if(!this.props.controlsVisible){
        this.showControls()
    }

    this.props.setHeld({
      id: this.props.id,
      held: true,
    })
  }

  pipetteUnselected = () => {

    this.props.setHeld({
      id: this.props.id,
      held: false,
    })
  }

  render() {
    return (
      <ul style={{
        zIndex: (this.props.controlsVisible)?99:null
      }}>
        <li
          onKeyDown={ (e)=>{
            if(e.keyCode === 13 || e.keyCode === 32) this.pipetteSelected()
          } }
          onMouseDown={this.pipetteSelected}
          onMouseUp={this.pipetteUnelected}
          onDragStart={(e)=>{
            this.props.setHeld({
              id: this.props.id,
              held: true,
            })
            this.props.setHeldObject({
              id: this.props.id,
              type: 'Pipette',
              htmlObj: e.target,
            })
          }}
          onDragEnd={(e)=>{
            this.props.setHeld({
              id: this.props.id,
              held: false,
            })
          }}
          draggable
          tabIndex={0}
          id={this.props.type+"_"+this.props.id}
          className={"draggable "+this.props.type}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>
          <p
            aria-hidden="true"
            className="label"
            // style={{
            //   display:
            //   (this.props.hasOwnProperty("heldObject") && this.props.heldObject.type !== null &&
            //   this.props.heldObject.type === "Pipette") &&
            //   (this.props.hasOwnProperty("lastDrop") && this.props.lastDrop.lastTarget !== null &&
            //    // this.props.lastDrop.lastTarget.id === (this.props.id + 1) &&
            //    (this.props.lastDrop.lastTarget.type === "Solution" ||
            //     this.props.lastDrop.lastTarget.type === "BlottingPaper")
            //   )?
            //    "none":
            //    "initial"
            // }}
          >{this.props.type}</p>
          <Graphics id={this.props.id} />
          <Controls id={this.props.id} />
        </li>
      </ul>
    )
  }
}

Pipette.propTypes = {
  createPipette: PropTypes.func,
};

Pipette.defaultProps = {
};
